import React, { useEffect, useState } from "react";
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { useQuery } from "react-query";
import { AgentWiseReportApi, AgentWiseReportDownloadApi, UserListApi } from "../../Api";
import { AxiosResponse } from "axios";
import { AgentWiseReportType } from "../../type";
import { RenderPaginationButtons } from "../../../Components/Paginations";
import { Dropdown } from "react-bootstrap";

function formatDate(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export default function AgentWiseReport() {
  const [Data, setData] = useState<AgentWiseReportType[]>([]);
  const [users, setUsers] = useState<{ id: number; name: string }[]>([]);
  const [selectDateName, setSelectDateName] = useState("Today");
  const [info, setInfo] = useState<{
    count: number;
    current_page: number;
    limit: number;
    total_page: number;
  }>();
  const [Filter, setFilter] = useState<{
    user_id: null | number;
    campaign_name: string;
    to: string;
    total_sms: string;
    from_date: string;
    to_date: string;
  }>({
    user_id: null,
    campaign_name: "",
    to: "",
    total_sms: "",
    from_date: formatDate(new Date()),
    to_date: formatDate(new Date()),
  });
  const [page, setPage] = useState(1);

  const userList = useQuery({
    queryKey: ["User-List-API"],
    queryFn: UserListApi,
    onSuccess: (resp: AxiosResponse) => {
      setUsers(resp.data?.users || []);
    },
    enabled: false,
  });

  const Report = useQuery({
    queryKey: ["Agent-Wise-Report", page, Filter],
    queryFn: AgentWiseReportApi,
    onSuccess: (resp: AxiosResponse) => {
      setData(resp.data?.data || []);
      setPage(resp.data?.info?.current_page || 1);
      setInfo(resp?.data?.info);
    },
    enabled: false,
  });

  const ReportDownload = useQuery({
    queryKey: ["Agent-Wise-Report-Download", page, Filter],
    queryFn: AgentWiseReportDownloadApi,
    onSuccess: (resp: AxiosResponse) => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(resp.data)
      link.download = `Agent_Wise_Report_${new Date().toISOString()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    enabled: false,
  });

  useEffect(() => {
    Report.refetch();
    userList.refetch();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    Report.refetch();
    // eslint-disable-next-line
  }, [page, selectDateName]);

  useEffect(() => {
    setPage(1)
    const handler = setTimeout(() => {
      Report.refetch();
    }, 300);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Filter.to, Filter.user_id, Filter.campaign_name, Filter.total_sms]);

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setPage(page);
    }
  };

  const handleClearSearchFilter = () => {
    setSelectDateName("Select Date");
    setFilter({
      user_id: null,
      campaign_name: "",
      to: "",
      total_sms: "",
      from_date: "",
      to_date: "",
    });
    Report.refetch();
  };

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="card mt-4">
          <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
            <div className="d-flex justify-content-between w-100 flex-wrap gap-3">
              <h2 className="mb-0 fs-3 d-block d-md-inline">Agent-wise Unique Customer Report</h2>
              <div className="d-flex gap-3 flex-wrap flex-grow-1 flex-md-grow-0">
                <Dropdown style={{ zIndex: 999 }}>
                  <Dropdown.Toggle
                    className="fw-semibold"
                    variant="primary"
                    style={{ minWidth: 130 }}
                  >
                    {selectDateName}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="p-3 Date-Filter-Menu">
                    <div className="d-flex flex-column">
                      <label className="mb-2 fw-semibold">From</label>
                      <input
                        type="date"
                        name="from"
                        value={Filter.from_date}
                        onChange={(e) =>
                          setFilter({ ...Filter, from_date: e.target.value })
                        }
                        className="form-control mb-3"
                      />

                      <label className="mb-2 fw-semibold">To</label>
                      <input
                        type="date"
                        name="to"
                        value={Filter.to_date}
                        onChange={(e) =>
                          setFilter({ ...Filter, to_date: e.target.value })
                        }
                        className="form-control mb-3"
                      />

                      <div className="d-flex justify-content-between">
                        <button
                          className="btn btn-primary w-100 me-1"
                          onClick={() => {
                            if (Filter.from_date && Filter.to_date) {
                              setPage(1)
                              setSelectDateName(`${Filter.from_date} To ${Filter.to_date}`);
                            }
                          }}
                        >
                          Apply
                        </button>

                        <button
                          className="btn btn-secondary w-100 ms-1"
                          onClick={() => {
                            setSelectDateName("Select Date");
                            setFilter({
                              ...Filter,
                              from_date: "",
                              to_date: ""
                            });
                          }}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
                <button
                  onClick={handleClearSearchFilter}
                  className="btn btn-secondary d-flex align-items-center justify-content-center gap-2"
                  style={{ minWidth: 130 }}
                >
                  <MdClear className="fs-5" />
                  Clear Filter
                </button>
                <button
                  onClick={() => ReportDownload.refetch()}
                  style={{ minWidth: 130 }}
                  className="btn btn-success d-flex align-items-center justify-content-center gap-2 text-white"
                  disabled={ReportDownload.isFetching}
                >
                  <BiExport className="fs-5" />
                  {ReportDownload.isFetching ? "Exporting.." : "Export"}

                </button>
              </div>
            </div>
          </div>
          <div className="card-body border-start-0 border-end-0 p-0">
            <div className="table-responsive">
              <table className="table table-hover table-bordered text-nowrap">
                <thead>
                  <tr>
                    <th style={{ width: 200 }}>SR No</th>
                    <th>User</th>
                    <th>Number</th>
                    <th>Total SMS</th>
                    <th>Campaign</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th>
                      <select
                        style={{ width: 240 }}
                        value={Filter.user_id || ""}
                        className="form-control w-100"
                        onChange={(e) => {
                          if (e.target.value === "All")
                            return setFilter({ ...Filter, user_id: null });
                          setFilter({
                            ...Filter,
                            user_id: Number(e.target.value),
                          });
                        }}
                      >
                        <option value="All">All</option>
                        {users?.map((item, i) => (
                          <option key={i} value={item?.id?.toString()}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th>
                      <input
                        className="form-control"
                        value={Filter.to}
                        onChange={(e) =>
                          setFilter({ ...Filter, to: e.target.value })
                        }
                      />
                    </th>
                    <th>
                      <input
                        className="form-control"
                        value={Filter.total_sms}
                        onChange={(e) =>
                          setFilter({ ...Filter, total_sms: e.target.value })
                        }
                      />
                    </th>
                    <th>
                      <input
                        className="form-control"
                        value={Filter.campaign_name}
                        onChange={(e) =>
                          setFilter({
                            ...Filter,
                            campaign_name: e.target.value,
                          })
                        }
                      />
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {Data && Data[0] ? (
                    Data.map((item, i) => (
                      <tr>
                        <td>{i + 1 + (page - 1) * 10}</td>
                        <td>
                          <p className="mb-0">{item?.user?.name}</p>
                          <p className="mb-0">
                            <small>{item?.user?.email}</small>
                          </p>
                        </td>
                        <td>{item?.to || " - "}</td>
                        <td>{item?.total_sms || " - "}</td>
                        <td>{item?.sms_campaign?.name || "- "}</td>
                      </tr>
                    ))
                  ) : !Report.isFetching ? (
                    <tr>
                      <td colSpan={5} height={50}>
                        <div className="text-center">
                          <p className="mb-0 fs-5 fw-semibold">
                            No data found
                          </p>
                        </div>
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
              {Report.isFetching ? (
                <center className="mb-3">
                  <i
                    className=" my-2 fa loader"
                    style={{ fontSize: "30px", color: "black" }}
                  ></i>
                </center>
              ) : null}
            </div>
            {info && info.total_page ? (
              <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                <RenderPaginationButtons
                  info={info}
                  currentPage={page}
                  handlePageChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}
